// Single source of truth for absolute URLs used in canonical, hreflang, OG and sitemap.
// Override at build time with PUBLIC_SITE_URL if the domain ever changes.
export const SITE_URL = (import.meta.env.PUBLIC_SITE_URL ?? "https://practical.at").replace(/\/$/, "");

export const DEFAULT_OG_IMAGE = "/icons/android-chrome-512x512.png";

/**
 * Given any pathname, return the DE and EN absolute URLs plus the canonical
 * for the current path. `/en` is the English prefix (see localizeHref()).
 */
export function alternateUrls(pathname: string) {
  const base = pathname.replace(/^\/en(?=\/|$)/, "") || "/";
  const de = SITE_URL + base;
  const en = SITE_URL + "/en" + (base === "/" ? "" : base);
  return { de, en, base };
}
